import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IMenu } from '../../../data/nav';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useLocation } from 'react-router-dom';

const NavItem: React.FC<IMenu> = ({ menu, link, icon, children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // 현재 경로가 해당 메뉴와 일치하는지 확인
  const isActive = link && location.pathname === link;
  
  // 자식 메뉴 중 하나라도 활성화되어 있는지 확인
  const hasActiveChild = children?.some(child => 
    child.link && location.pathname.startsWith(child.link)
  );
  
  // 자식 메뉴가 활성화되어 있으면 부모 메뉴도 열림
  const [isOpen, setIsOpen] = useState<boolean>(hasActiveChild || false);
  
  // 경로가 변경될 때마다 자식 메뉴 활성화 상태 확인
  useEffect(() => {
    if (hasActiveChild) {
      setIsOpen(true);
    }
  }, [hasActiveChild]);

  const onClickParentMenu = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (children) {
      setIsOpen(state => !state);
    }
    if (link) {
      // 외부 링크인 경우 새 탭에서 열기
      if (link.startsWith('http://') || link.startsWith('https://')) {
        window.open(link, '_blank', 'noopener,noreferrer');
      } else {
        navigate(link);
      }
    }
  };

  return (
    <li className="!mb-1">
      <div className="!relative !group">
        <button
          onClick={onClickParentMenu}
          className={`!w-full !flex !items-center !gap-3 !rounded-lg !transition-all !duration-200 !px-4 !py-3 ${
            isActive
              ? '!bg-blue-600 !text-white'
              : hasActiveChild
              ? '!text-gray-100 !bg-gray-700'
              : '!text-gray-300 hover:!text-white hover:!bg-gray-700'
          }`}
        >
          {/* 아이콘 */}
          <span className="!flex !items-center !justify-center !text-base !w-5 !h-5">
            {icon}
          </span>
          
          {/* 메뉴명 */}
          <span className="!flex-1 !text-left !text-sm !font-medium">
            {menu}
          </span>
          
          {/* 화살표 */}
          {children && (
            <FontAwesomeIcon
              icon={faChevronRight}
              className={`!w-3 !h-3 !transition-transform !duration-200 ${
                isOpen ? '!rotate-90' : ''
              }`}
            />
          )}
        </button>
      </div>
      
      {/* 자식 메뉴 */}
      {children && (
        <div
          className={`!overflow-hidden !transition-all !duration-300 ${
            isOpen ? '!max-h-96' : '!max-h-0'
          }`}
        >
          <ul className="!ml-4 !mt-1 !border-l-2 !border-gray-700">
            {children.map(childMenu => (
              <NavItem key={childMenu.menu} {...childMenu} />
            ))}
          </ul>
        </div>
      )}
    </li>
  );
};

export default NavItem;
